/**
 * Abre um anexo autenticado.
 *
 * <p>O jeito óbvio — `<a href>` com `target="_blank"` — não funciona aqui, e o motivo é
 * o mesmo das imagens da wiki: a aba nova pede o arquivo sem o token de sessão, e a API
 * exige sessão até no GET. O sintoma era abrir um print no Dev Board e receber o
 * ProblemDetail de 401 no lugar da imagem.
 *
 * <p>Então o clique baixa o arquivo via fetch autenticado e entrega o object URL: o que
 * o navegador renderiza (imagem, PDF) abre em aba nova; o resto desce como download com
 * o nome original — o mesmo serviço do `?nome=` que o link antigo prometia.
 */
import { apiBlob } from '../api/cliente';

/** O que o navegador mostra em aba: o resto é download. */
const RENDERIZAVEIS = new Set(['png', 'jpg', 'jpeg', 'webp', 'gif', 'pdf']);

export async function abrirAnexo(url: string, nomeOriginal: string): Promise<void> {
  const blob = await apiBlob(url);
  const objeto = URL.createObjectURL(blob);
  const extensao = (nomeOriginal.split('.').pop() ?? '').toLowerCase();

  if (RENDERIZAVEIS.has(extensao)) {
    window.open(objeto, '_blank', 'noopener');
  } else {
    const elo = document.createElement('a');
    elo.href = objeto;
    elo.download = nomeOriginal;
    elo.click();
  }

  // Depois que a aba ou o download já leram o blob. Um minuto é folga, não precisão.
  setTimeout(() => URL.revokeObjectURL(objeto), 60_000);
}
